import React from 'react'
import { Auth } from 'aws-amplify'
import { Container } from 'react-bootstrap'
import { XeroButton } from '../../components/ui/xeroButton/xeroButton'

const Redirect = () => {
	React.useEffect(() => {
		Auth.federatedSignIn({ customProvider: '' })
	}, [])

	return (
		<Container>
			<p>Redirect in progress, if you aren&apos;t redirected soon please click the button below</p>
			<XeroButton text="Sign in with Xero" onClick={() => Auth.federatedSignIn({ customProvider: '' })} />
		</Container>
	)
}

export default Redirect
